import {
  UserType,
  useUserHasFeature,
  useUserSession,
  type UserSession,
} from '@solinkcorp/authentication';

const MANAGEMENT_USER_TYPES: ReadonlyArray<UserType> = [
  UserType.SOLINK,
  UserType.CLOUD,
  UserType.RESELLER,
  UserType.ADMIN,
];

export function isManagementUser(user: UserSession | undefined): boolean {
  if (!user) return false;
  return MANAGEMENT_USER_TYPES.includes(user.profile.userType);
}

export function isLocationRestrictedUser(user: UserSession | undefined): boolean {
  if (!user) return false;
  const { locationIds, locationGroupIds } = user.profile;
  return !!(locationIds?.length || locationGroupIds?.length);
}

/**
 * Mirrors the backend `canManageSolinkApiKeys` resolver (DATA-11543):
 * MANAGEMENT role + the `manageSolinkApiKeys` user feature, and never a
 * location-restricted admin.
 */
export default function useCanManageSolinkApiKeys(): boolean {
  const user = useUserSession();
  const hasFeature = useUserHasFeature('manageSolinkApiKeys');
  return hasFeature && isManagementUser(user) && !isLocationRestrictedUser(user);
}
